export const veracruz = {
	nombre: "Vera Cruz",
	dia: "Lunes Santo",
	nombrecompleto:
		"Muy Ilustre, Antigua, Venerable, Franciscana Hermandad  y Cofradía de Penitencia del Santísimo Cristo de la Vera Cruz y Nuestra Señora de la Soledad",
	sede: "Iglesia Conventual de Nuestra Señora de los Remedios",
	pasos: 2,
	distancia: [1050, 1130],
	penitentes: 200,
	cargadores: 124,
	web: "http://www.diariodecadiz.es/semana_santa/Vera-Cruz_0_1229277804.html",

	ida: [
		{ lng: -6.295801, lat: 36.5346593 },
		{ lng: -6.2956783, lat: 36.5345494 },
		{ lng: -6.2955415, lat: 36.5346744 },
		{ lng: -6.2948415, lat: 36.5345224 },
		{ lng: -6.29379, lat: 36.5343123 },
		{ lng: -6.293491, lat: 36.5330548 },
		{ lng: -6.2929532, lat: 36.531614 },
		{ lng: -6.2926568, lat: 36.5312509 },
		{ lng: -6.2929217, lat: 36.531079 },
		{ lng: -6.2921914, lat: 36.5302541 },
		{ lng: -6.2928137, lat: 36.529767 },
		{ lng: -6.2936103, lat: 36.5296937 },
		{ lng: -6.2937444, lat: 36.5296937 },
		{ lng: -6.294525, lat: 36.5296366 },
		{ lng: -6.2946135, lat: 36.5295601 },
		{ lng: -6.295099, lat: 36.5295407 },
		{ lng: -6.29535, lat: 36.52899 }
	],
	vuelta: [
		{ lng: -6.29535, lat: 36.52899 },
		{ lng: -6.2957078, lat: 36.5290643 },
		{ lng: -6.2954101, lat: 36.5297583 },
		{ lng: -6.2956622, lat: 36.5299523 },
		{ lng: -6.2952854, lat: 36.5303478 },
		{ lng: -6.2950172, lat: 36.5308327 },
		{ lng: -6.2949206, lat: 36.5308371 },
		{ lng: -6.294926, lat: 36.531461 },
		{ lng: -6.2964602, lat: 36.5317714 },
		{ lng: -6.2964025, lat: 36.5318479 },
		{ lng: -6.2967941, lat: 36.5325418 },
		{ lng: -6.2971267, lat: 36.5330472 },
		{ lng: -6.2984625, lat: 36.5343339 },
		{ lng: -6.2980118, lat: 36.5347477 },
		{ lng: -6.296778, lat: 36.5341938 },
		{ lng: -6.2964427, lat: 36.5344265 },
		{ lng: -6.296318, lat: 36.5342929 },
		{ lng: -6.2958245, lat: 36.5346485 }
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-26T19:25",
			latlng: [36.53466, -6.2958]
		},
		{
			name: "Nueva",
			hora: "2018-03-26T20:35",
			latlng: [36.53062, -6.29249]
		},
		{
			name: "Catedral",
			hora: "2018-03-26T21:35",
			latlng: [36.52899, -6.29535]
		},
		{
			name: "Candelaria",
			hora: "2018-03-26T22:35",
			latlng: [36.53106, -6.295]
		},
		{
			name: "Palillero",
			hora: "2018-03-26T23:00",
			latlng: [36.53196, -6.2965]
		},
		{
			name: "Valverde Barrié",
			hora: "2018-03-26T23:10",
			latlng: [36.53254, -6.29679]
		}
	],
	itinerario: [
		[
			"Plaza de San Francisco",
			"Plaza Stmo Cristo de la Vera Cruz",
			"Rafael de la Viesca",
			"Avda. 4 de Diciembre de 1977",
			"Cristóbal Colon",
			"Nueva"
		],
		[
			"Plaza San Juan de Dios",
			"Pelota",
			"Plaza Pio XII",
			"Estación de Penitencia en la S.I.C."
		],
		[
			"Arquitecto Acero",
			"Plaza de Pío XII",
			"Compañía",
			"Santiago",
			"Plaza Candelaria"
		],
		["Montañés", "Palillero"],
		["Novena"],
		[
			"Ancha",
			"San José",
			"San Pedro",
			"Sagasta (Izq.)",
			"Tinte",
			"Plaza de San Francisco"
		]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/veracruz.js